import React, { MouseEventHandler } from "react"
import cn from "classnames"
import { ClassProps } from "../../utility/common/props"
import { faPlus } from "@fortawesome/pro-solid-svg-icons/faPlus"
import { ButtonProps } from "react-bootstrap"
import IconButton from "../IconButton/IconButton"
import styles from "./AddButton.module.scss"
import { faUserPlus } from "@fortawesome/pro-solid-svg-icons"

export interface AddButtonProps extends ClassProps {
    text?: string
    iconClassName?: string
    onClick: MouseEventHandler
    variant?: ButtonProps["variant"]
    disabled?: boolean
    testId?: string
    userAddIcon?: boolean
}

const defaultVariant = "secondary"

const AddButton: React.FC<AddButtonProps> = props => {
    const { onClick, text, className, iconClassName, disabled, testId, variant = defaultVariant, userAddIcon = false } = props

    return (
        <IconButton
            variant={variant}
            className={cn(styles.btnAdd, className)}
            onClick={onClick}
            icon={userAddIcon ? faUserPlus : faPlus}
            iconClassName={iconClassName}
            disabled={disabled}
            testId={testId}
        >
            {text}
        </IconButton>
    )
}

export default AddButton
